// extracted by mini-css-extract-plugin
module.exports = {"container":"_2xOS0G-prTmDR4zxeHqrkS"};